import configData from '../../config'

export function getEnvironmentType() {
  return getConfigVariable('APP_ENV')
}

export function isStagingEnvironment() {
  const newName = 'staging'
  const oldName = 'development' // We want to move away from this old name.
  return getEnvironmentType() === newName || getEnvironmentType() === oldName
}

type ConfigKeys = keyof typeof configData

/**
 * Retrieves a required configuration value from the central config object.
 * @param key The key of the configuration value to retrieve (e.g., 'API_BASE_URL'). Must be a key from src/config.js.
 * @returns The configuration value as a string.
 * @throws Error if the key's value is not a non-empty string in the config object.
 */
function getConfigVariable(key: ConfigKeys): string {
  const value = configData[key]

  if (value.trim() === '') {
    throw new Error(
      `Configuration value for key '${String(key)}' is required and must be a non-empty string. Received: '${value}' (type: ${typeof value})`,
    )
  }
  return value
}

export function getGraphQLEndpoint(): string {
  return getConfigVariable('GRAPHQL_ENDPOINT')
}

export function getReactAppServerURL(): string {
  return getConfigVariable('API_BASE_URL')
}

export function getCommitSHA(): string {
  return getConfigVariable('COMMIT_SHA')
}

export function getSentryDsn(): string {
  // Let's use a hardcoded DSN for now.
  return 'https://bce93c99d7b69ca6a255d420efe286f9@o4510742054174720.ingest.de.sentry.io/4510742090219600'
}
